export const iconFontAwesomeWritingNotdef = (
	<i className="fa-solid fa-notdef"></i>
);
